import consumer from "./consumer"

consumer.subscriptions.create("InformationRequestChannel", {
    connected() {
    },

    received(data) {
        if (data.status === 'accepted' || data.status === 'rejected') {
            const acceptButton = document.getElementById(`information-request-message-action-${data.deal_information_request_id}-accept`);
            const rejectButton = document.getElementById(`information-request-message-action-${data.deal_information_request_id}-reject`);

            acceptButton.disabled = true;
            rejectButton.disabled = true;
        }

        if (data.status === 'information_provided') {
            const infoButton = document.getElementById(`information-request-message-action-${data.deal_information_request_id}-add-information`);
            infoButton.disabled = true;
        }
    }
});
